import {
  propOr
} from 'ramda';

const formatInfluencerApplication = (data) => {
  return {
    email: propOr('', 'email', data),
    first_name: propOr('', 'firstName', data),
    last_name: propOr('', 'lastName', data),
    username: propOr('', 'username', data),
    hair_color: propOr('', 'hairColor', data),
    height: propOr('', 'height', data),
    location: propOr('', 'location', data),
    instagram_username: propOr('', 'instagramUsername', data),
    twitter_username: propOr('', 'twitterUsername', data),
    weight: propOr('', 'weight', data),
    phone_number: propOr('', 'phoneNumber', data),
    good_fit_info: propOr('', 'goodFitInfo', data),
    eye_color: propOr('', 'eyeColor', data),
    zodiac_sign: propOr('', 'zodiacSign', data),
    bust_size: propOr('', 'bustSize', data),
    experience: propOr('', 'experience', data),
    body_type: propOr('', 'bodyType', data),
    gender: propOr('', 'gender', data),
    birthday: propOr('', 'birthday', data)
  }
}
export default formatInfluencerApplication;